import { useConnectModal } from '@rainbow-me/rainbowkit';
import { useTranslations } from 'next-intl';

import { Button } from '@web/ui/components';
import { env } from '@web/utils/env';
import { SignInRainbowKitProvider } from '@web/utils/rainbowkit/RainbowKitProvider';

interface ISignInWallet {
  fullWidth?: boolean;
}

const _SignInWallet = ({ fullWidth }: ISignInWallet) => {
  const t = useTranslations();
  const { openConnectModal } = useConnectModal();

  return (
    <Button
      label={t('CONNECT_RAINBOW')}
      onClick={openConnectModal}
      fullWidth={fullWidth}
    />
  );
};

/**
 * The public build keeps the button so the header still reads as the product,
 * but inert: there is no account layer behind it, and opening a wallet modal
 * would walk someone through connecting and signing for nothing. Mounting
 * RainbowKit is also what loads the wallet connectors and probes the page for
 * an injected provider, which is worth avoiding on a site that cannot transact.
 */
const DisabledSignIn = ({ fullWidth }: ISignInWallet) => {
  const t = useTranslations();

  return (
    <Button
      label={t('CONNECT_RAINBOW')}
      disabled
      fullWidth={fullWidth}
      onClick={() => undefined}
    />
  );
};

export const SignInWallet = ({ fullWidth }: ISignInWallet) =>
  env.SHELL_MODE ? (
    <DisabledSignIn fullWidth={fullWidth} />
  ) : (
    <SignInRainbowKitProvider>
      <_SignInWallet fullWidth={fullWidth} />
    </SignInRainbowKitProvider>
  );
